import { Injectable, inject, signal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RouteWatcherService {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  private readonly signals = {
    routesToWatch: signal<string[]>([]),
    currentUrlSegments: signal<string[]>([]),
    queryParams: signal<string>(''),
  };

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects.split('?')[0];
        const queryParams = event.urlAfterRedirects.split('?')[1];

        this.signals.currentUrlSegments.set(url.split('/').filter(Boolean));
        this.signals.queryParams.set(queryParams);
      });
  }

  getWatchedRoutes(routesToWatch: string[]) {
    return routesToWatch.filter((route) =>
      this.signals.currentUrlSegments().includes(route)
    );
  }

  getCurrentSection(sections: string[]): string | undefined {
    return (
      this.signals.currentUrlSegments().find((s) => sections.includes(s)) ||
      undefined
    );
  }

  getQueryParam(param: string): string | null {
    const queryParams = new URLSearchParams(this.signals.queryParams());
    return queryParams.get(param);
  }

  getRouteParam(index: number): string | undefined {
    return this.signals.currentUrlSegments()[index];
  }
}
